import script from "./ExpertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpertModal.vue?vue&type=script&setup=true&lang=js"

import "./ExpertModal.vue?vue&type=style&index=0&id=f7efe0ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7efe0ce"]])

export default __exports__